var chunkPrefetchChunkToChildrenMap = {"5090":[6956,6956],"3004":[6956,3771,7604],"2709":[6956,3771],"1895":[6956,9886],"9481":[6956,1862],"2717":[6956],"7526":[6956],"4998":[2478],"9852":[6956],"1793":[6956],"4606":[5383,4426,9948],"9948":[6956],"3468":[6956],"9841":[6956,3771]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
